




























import { computed, defineComponent, inject, Ref, ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import useVaultView from "@/hooks/useVaultView";
import { isAttachmentFile } from "@/lib/fileHelpers";
import { AttachmentFile, PostFileData } from "@/types";
import BaseChip from "@/components/BaseChip";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import { AddingFilesOptions } from "@/components/CreatePost/types";
import VaultModal from "@/components/VaultModal";

export default defineComponent({
  name: "OptionAddCover",
  components: { VaultModal, BaseInputFileWithPreview, BaseChip },
  setup(_, { emit }) {
    const { showPrivateVault: showVault, showVaultOrNative } = useVaultView();

    const postAddFiles = inject<
      (
        files: FileList | File[],
        {
          unshift,
          publicAccess,
          metadata,
        }?: {
          unshift?: boolean | undefined;
          publicAccess?: boolean | undefined;
          metadata?: Record<string, string> | undefined;
        },
        cb?: ((file?: ContentFile | undefined) => void) | undefined
      ) => Promise<void>
    >("postAddFiles", async (_: FileList | File[]) => {});
    const postAddFilesFromVault = inject<
      (files: AttachmentFile[], options?: AddingFilesOptions | undefined) => Promise<void>
    >("postAddFilesFromVault", async (_: AttachmentFile[]) => {});
    const fileList = inject<Ref<readonly PostFileData[]>>("fileList", ref([]));

    const haveCover = computed(() => fileList.value.some(file => file.public));
    const postSubject = computed<Subject<VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS>>(() => {
      return {
        subjectId: "0",
        subjectType: VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS,
      };
    });

    const onAddFileButtonHandler = (showNativeFileUploader: () => void) => {
      if (haveCover.value) return;
      showVaultOrNative(showNativeFileUploader, false);
    };
    const onNativeAddFileHandler = (files: FileList) => {
      postAddFiles(files, {
        publicAccess: true,
        unshift: true,
      });
    };

    const onAddFiles = (files: (AttachmentFile | File)[], options: AddingFilesOptions) => {
      try {
        if (files.every(isAttachmentFile)) {
          postAddFilesFromVault(files, options);
        } else {
          postAddFiles(files as File[], options);
        }
      } finally {
        emit("close");
      }
    };
    const closeVault = () => {
      showVault.value = false;
    };
    return {
      postSubject,
      showVault,
      onAddFiles,
      onAddFileButtonHandler,
      onNativeAddFileHandler,
      closeVault,
    };
  },
});
